module.exports = __webpack_public_path__ + "2f7f4f4e29bdba679380094ab6d2ccd6.jpg";